import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";


export interface NgbDateTimeStruct extends NgbDateStruct, NgbTimeStruct {}

export class DateTimeModel implements NgbDateTimeStruct{
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;
    second: number;

    timeZoneOffset: number;

    public constructor( init?: Partial<DateTimeModel>
                        /*protected commonService: CommonService*/) {
        Object.assign(this, init);
    }

public static fromUTCString(dateString: string): DateTimeModel {
  if (!dateString) return null;

  const s = dateString.trim();

  const m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})\.?\s*(\d{1,2}):(\d{2})(?::(\d{2}))?\s*$/);
  if (m) {
    const day    = parseInt(m[1], 10);
    const month  = parseInt(m[2], 10) - 1;
    const year   = parseInt(m[3], 10);
    const hour   = parseInt(m[4], 10);
    const minute = parseInt(m[5], 10);
    const second = m[6] ? parseInt(m[6], 10) : 0;

    const date = new Date(year, month, day, hour, minute, second);
    if (isNaN(date.valueOf())) return null;

    return new DateTimeModel({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: date.getSeconds(),
      timeZoneOffset: date.getTimezoneOffset()
    });
  }

  const parsed = new Date(s);
  if (isNaN(parsed.valueOf())) return null;

  return new DateTimeModel({
    year: parsed.getFullYear(),
    month: parsed.getMonth() + 1,
    day: parsed.getDate(),
    hour: parsed.getHours(),
    minute: parsed.getMinutes(),
    second: parsed.getSeconds(),
    timeZoneOffset: parsed.getTimezoneOffset()
  });
}

public static fromStringToDateTime(dateTimeString: string): DateTimeModel{
    const dateTime = new Date(dateTimeString);
    const isValidDate = !isNaN(dateTime.valueOf());

    if (!dateTimeString || !isValidDate) {
        return null;
      }

      return new DateTimeModel({
        year: dateTime.getFullYear(),
        month: dateTime.getMonth() + 1,
        day: dateTime.getDate(),
        hour: dateTime.getHours(),
        minute: dateTime.getMinutes(),
        second: dateTime.getSeconds(),
        timeZoneOffset: dateTime.getTimezoneOffset()
      });
}

    private isInteger(value: any): value is number {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }

    public toString(): string {
        if (this.isInteger(this.year) && this.isInteger(this.month) && this.isInteger(this.day)) {
            const year = this.year.toString();
            const month = this.PadLeft(this.month.toString(), '0', 2);
            const day = this.PadLeft(this.day.toString(), '0', 2);

            if (!this.hour) {
                this.hour = 0;
            }
            if (!this.minute) {
                this.minute = 0;
            }
            if (!this.second) {
                this.second = 0;
            }
            if (!this.timeZoneOffset) {
                this.timeZoneOffset = new Date().getTimezoneOffset();
            }

            const hour = this.PadLeft(this.hour.toString(), '0', 2)
            const minute = this.PadLeft(this.minute.toString(), '0', 2)
            const second = this.PadLeft(this.second.toString(), '0', 2)

            const tzo = -this.timeZoneOffset;
            const dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                const norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };

            const isoString = `${pad(year)}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
            return isoString;
        }

        return null;
    }

    PadLeft(text : string, padChar : string, size : number): string {
        return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
    }
}